import { Component, Input, OnInit } from '@angular/core';
import { ENTITLEMENTS, EntitlementsHelperService, LINE_OF_BUSINESS_ENUM, LOGIN_INFO_REDUCER_NAME, UserInfoStateStructure, USER_ROLE } from '@ptl/account-management';
import { ClientBrandData, ClientListData, ClientData, SUB_CLIENT_MAPPING, ClientBrandBusinessType } from '../interfaces/login-as-employer.interface';
import { ReducerUtilityService } from "src/app/shared/utility-services/reducer-utility.service";
import { ProducerService } from '../producer.service';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { HttpParams } from '@angular/common/http';
import { ProducerAgencyHelperService } from '../producer-agency-helper.service';
import { AuthoringModeService } from 'src/app/shared/services/authoring-mode.service';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-producer-login-as-employer',
    templateUrl: './producer-login-as-employer.component.html',
    styleUrls: ['./producer-login-as-employer.component.scss'],
    standalone: false
})
export class ProducerLoginAsEmployerComponent implements OnInit {

  @Input() noEntitlementsMessage: string;

  @Input() buttonDisplayOption: string;

  isAuthoring = false;
  hasEntitlements = false;

  CLIENT_ADMIN_SSO_URL = '/emssvc/x-services/secure/sso/outbound/auto/v1/vendor/PRODUCERTOEMPLOYER';

  loginEmpForm: UntypedFormGroup;
  brandData: ClientBrandData;
  clientLists: ClientListData;

  allClients: ClientData[];
  filteredClients: ClientData[];

  businessTypeSubGroupList: ClientData[] = [];
  businessTypeClientList: ClientData[] = [];

  noClients: boolean = false;
  isLoading: boolean = true;

  oldPortalButtonLabel: string = "Submit";
  newPortalButtonLabel: string = "Submit to New Portal";
  showOnlyNewButton: boolean;
  showOnlyOldButton: boolean;
  showBothButtons: boolean;

  constructor(
    private fb: UntypedFormBuilder,
    private producerService: ProducerService,
    private reducerUtilityService: ReducerUtilityService,
    private agencyHelper: ProducerAgencyHelperService,
    private entitlementsHelper: EntitlementsHelperService,
    private authoringMode: AuthoringModeService,
    private cookieService: CookieService
  ) {
    this.loginEmpForm = this.fb.group({
      client: this.fb.control(''),
      businessType: this.fb.control(''),
      businessSubGroup: this.fb.control(''),
      clientDropdown: this.fb.control('')
    });
  }

  async ngOnInit() {
    this.buttonDisplayOption;

    if (this.buttonDisplayOption === "showNewPortalSubmitButtonOnly") {
      this.newPortalButtonLabel = "Submit";
      this.showOnlyNewButton = true;
      this.showOnlyOldButton = false;
      this.showBothButtons = false;
    } else if (this.buttonDisplayOption === "showOldPortalSubmitButtonOnly") {
      this.oldPortalButtonLabel = "Submit";
      this.showOnlyNewButton = false;
      this.showOnlyOldButton = true;
      this.showBothButtons = false;
    } else if (this.buttonDisplayOption === "showBothPortalSubmitButtons") {
      this.oldPortalButtonLabel = "Submit to Old Portal";
      this.newPortalButtonLabel = "Submit to New Portal";
      this.showOnlyNewButton = false;
      this.showOnlyOldButton = false;
      this.showBothButtons = true;
    }
 
    this.isAuthoring = this.authoringMode.getAuthoringMode();

    let selectedAgency = await this.entitlementsHelper.getSelectedAgencyPromise();
    const loginInfo: UserInfoStateStructure = this.reducerUtilityService.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);
    const lob: LINE_OF_BUSINESS_ENUM = await this.entitlementsHelper.getCurrentLobPromise();

    this.hasEntitlements = await this.entitlementsHelper.entitlementValueForSelectedAgencyByNameAndLob(ENTITLEMENTS.CLIENT_ADMIN, lob, loginInfo?.userInfo?.role as USER_ROLE);

    const isInternal = loginInfo?.userInfo?.role.toUpperCase() === 'INTERNAL';

    if (this.isAuthoring || this.hasEntitlements || isInternal) {

      // let brandResponse = await this.producerService.getLoginAsEmployerBrandData();
      // let curBrand = this.brandService.getCurrentBrand();
      // TODO: this may be different for each ASP, need to get that resolved.
      this.brandData = {
        "businessTypeOptions": [
          {
            "label": "Please Select",
            "value": "",
            "selected": true
          },
          {
            "label": "Association",
            "value": "A"
          },
          {
            "label": "Broker Pool",
            "value": "B"
          },
          {
            "label": "Consortium",
            "value": "C"
          },
          {
            "label": "Non-Affiliated",
            "value": "N"
          }
        ]
      }

      // TODO: need a CATCH if the service fails to show error and stop spinner.
      let clientListResponse = await this.producerService.getLoginAsEmployerClientLists(selectedAgency.agencyId, loginInfo.userId);

      if (clientListResponse.groupList) {

        this.clientLists = clientListResponse.groupList;
        this.allClients = this.clientLists.groups;


        this.filteredClients = this.allClients;

        // Apply client filter to autocomplete when user is typing
        this.loginEmpForm.get('client').valueChanges.subscribe((newVal: ClientData | string) => {
          // An autocomplete value can be either a string (user typing), or a client (user selected client)
          let stringVal = (typeof newVal === 'string') ? newVal.toLowerCase() : this.clientDisplay(newVal);

          this.filteredClients = this.allClients.filter((client: ClientData) => {
            return this.clientDisplay(client)?.toLowerCase().indexOf(stringVal) !== -1;
          });
        });
      }

      this.isLoading = false;

      // Update sublists when user changes the business type or subgroup

      this.loginEmpForm.get('businessType').valueChanges.subscribe((newVal: ClientBrandBusinessType) => {
        this.updateSubTypeClientList(newVal);
        this.updateBusinessTypeClientList();

        this.loginEmpForm.get('businessSubGroup').reset();
        this.loginEmpForm.get('clientDropdown').reset();
      });

      this.loginEmpForm.get('businessSubGroup').valueChanges.subscribe((newVal: ClientData) => {
        this.updateBusinessTypeClientList(newVal);

        this.loginEmpForm.get('clientDropdown').reset();
      });

    }
  }

  submtAuto(isNewPortal: boolean) {

    if(this.cookieService.check('OAM_GITO')){
      this.cookieService.delete('OAM_GITO', '/', window.location.hostname.substring(window.location.hostname.indexOf('.')));
    }

    let client = this.loginEmpForm.get('client').value as ClientData;
    if (isNewPortal) {
      this.submitToNewPortal(client);
    } else {
      this.submit(client);
    }
  }

  submitCriteria(isNewPortal: boolean) {
    let client = this.loginEmpForm.get('clientDropdown').value as ClientData;
    if (isNewPortal) {
      this.submitToNewPortal(client);
    } else {
      this.submit(client);
    }
  }

  submit(client: ClientData) {
    const loginInfo: UserInfoStateStructure = this.reducerUtilityService.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);

    let params = new HttpParams()
      .set('agentId', loginInfo.userId)
      .set('mcClientId', client.clientId || client.subClientId + '')
      .set('deepLink', this.agencyHelper.getDeepLinkEmployer());

    let ssoUrl = this.CLIENT_ADMIN_SSO_URL + '?' + params.toString();

    var link = document.createElement('a');
    link.href = ssoUrl;
    link.target = '_blank';

    //In FF link must be added to DOM to be clicked
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  submitToNewPortal(client: ClientData) {
    let deepLink = this.agencyHelper.getDeepLinkNewEmployer().replace("www", "");

    const urlPrefix = "https://employer";
    const urlSuffix = "/employer/producer?clientId=";
    let clientId = client.clientId || client.subClientId;

    let ssoToNewUrl = urlPrefix + deepLink + urlSuffix + clientId;

    var link = document.createElement('a');
    link.href = ssoToNewUrl;
    link.target = '_blank';

    //In FF link must be added to DOM to be clicked
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  updateSubTypeClientList(businessType: ClientBrandBusinessType) {
    let mappingVal: string = SUB_CLIENT_MAPPING[businessType?.value];
    let clientList: ClientData[] = this.clientLists[mappingVal];

    if (clientList && clientList[0] && clientList[0].subgroupList) {
      this.businessTypeSubGroupList = clientList;
    }
    else {
      this.businessTypeSubGroupList = [];
    }
  }

  updateBusinessTypeClientList(subGroup?: ClientData) {
    if (!this.businessTypeSubGroupList.length) {
      let businessType = this.loginEmpForm.get('businessType').value as ClientBrandBusinessType;
      this.businessTypeClientList = this.allClients.filter((client) => client.entityType === businessType?.value);
    }
    // Use the subgroup list if we have a sub group selected
    else if (subGroup && subGroup.subgroupList) {
      this.businessTypeClientList = subGroup.subgroupList;
    }
    else {
      this.businessTypeClientList = [];

      // this is the case when there are subgroups, but no subgroup has been selected
      this.noClients = false;
      return;
    }

    if (this.businessTypeClientList.length) {
      this.noClients = false;
    }
    else {
      this.noClients = true;
    }
  }

  clientDisplay(client: ClientData) {
    if (!client || !client.clientName) {
      return null;
    }

    return (client.subClientNumber ? client.subClientNumber : client.clientNumber) + ' - ' + client.clientName;
  }
}
